import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import { useSettingsStore } from '@/stores/useSettingsStore';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className }) => {
  const { settings } = useSettingsStore();
  const [isMobile, setIsMobile] = useState(false);
  const [systemTheme, setSystemTheme] = useState<'light' | 'dark'>('dark');
  
  // Detect if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Detect system theme preference
  useEffect(() => {
    const checkSystemTheme = () => {
      setSystemTheme(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    };
    
    checkSystemTheme();
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', checkSystemTheme);
    return () => mediaQuery.removeEventListener('change', checkSystemTheme);
  }, []);
  
  // Determine which logo to use based on device and theme
  const getLogoSrc = () => {
    const isDark = settings.theme === 'dark' || (settings.theme === 'system' && systemTheme === 'dark');
    
    if (isMobile) {
      // Mobile logos (just icon, no text)
      return isDark 
        ? '/images/HQ Transparent-04.png'  // Dark mode mobile
        : '/images/HQ Transparent-03.png'; // Light mode mobile
    } else {
      // Desktop/tablet logos (icon + text)
      return isDark
        ? '/images/HQ Transparent-02.png'  // Dark mode desktop
        : '/images/HQ Transparent-01.png'; // Light mode desktop
    }
  };

  return (
    <div className={cn('transition-transform group-hover:scale-105', className)}>
      <img
        src={getLogoSrc()}
        alt="Light Hunt"
        className={cn(
          isMobile ? 'h-12' : 'h-11', // Increased from h-8 to h-12 for mobile
          'w-auto',
          isMobile ? 'max-w-[48px]' : 'max-w-[224px]' // Increased from 32px to 48px for mobile
        )}
      />
    </div>
  );
};